export default __webpack_public_path__ + "static/media/Photo 2 - BR - Ilot intérieur.46ad72d2.png";